import React, { Component } from 'react';
import FaArrowLeft from 'react-icons/lib/ti/arrow-left';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';

import { compose } from 'ramda';
import {
  retranscodeVideo,
  fetchVideo,
  fetchCurrentUser,
  log,
  revertVideo,
} from 'src/actions';
import AnimatedLogo from 'src/assets/logo.gif';
import { withProviders } from 'src/common/hocs/with-providers';
import { selectAllMeState } from 'src/common/state/me/me-selectors';
import { selectAllVideosState } from 'src/dashboard/state/videos/videos-selectors';
import { Modal, ModalFooter, ModalBody } from 'src/misc/modals/modals';
import Player from 'src/misc/player/Player';
import { getVideo, selectIsMobile } from 'src/misc/selectors';
import { getBestSourceUrl, getBestFile } from 'src/misc/utilities';
import VideoEditor from 'src/misc/videoEditor/VideoEditor';

import './editor.css';

const mapStateToProps = (state, ownProps) => {
  const videos = selectAllVideosState(state);
  return {
    me: selectAllMeState(state),
    video: getVideo(videos.cache, ownProps.shortcode),
    mobile: selectIsMobile(state),
    query: ownProps.query,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dispatch,
    fetchVideo: (version = ownProps.version) => {
      return dispatch(fetchVideo(ownProps.shortcode, version));
    },
    retranscodeVideo: (video, options) => {
      return dispatch(retranscodeVideo(video, options));
    },
    fetchCurrentUser: () => {
      return dispatch(fetchCurrentUser());
    },
    revertToOriginal: (shortcode) => {
      return dispatch(revertVideo(shortcode));
    },
    onPlaybackError: (data) => {
      log(`[FE Error] Playback failure: ${JSON.stringify(data)}`);
    },
  };
};

class Editor extends Component {
  constructor() {
    super();
    this.state = {
      isFetching: false,
      isProcessing: false,
      tagInputValue: '',
      revertModalOpen: false,
    };
    this.setState = this.setState.bind(this);
  }
  componentWillMount() {
    if (!this.props.video || !getBestSourceUrl(this.props.video)) {
      this.setState({ isFetching: true });

      this.props.fetchVideo().then(() => {
        this.setState({ isFetching: false });
      });
    }
  }

  toggleRevertModal() {
    this.setState({
      revertModalOpen: !this.state.revertModalOpen,
    });
  }

  render() {
    const self = this;

    return (
      <div className="editor-container">
        <a
          className="back"
          href="/"
          onClick={(e) => {
            e.preventDefault();
            browserHistory.goBack();
          }}
        >
          <FaArrowLeft />
        </a>
        <div className="editor">
          <Modal
            isOpen={this.state.revertModalOpen}
            toggle={this.toggleRevertModal.bind(this)}
            className="app-modal"
            title="Revert Original"
            darkMode={this.props.me.dark_mode}
          >
            <ModalBody>
              Are you sure you want to revert to the original version of your
              video?
            </ModalBody>
            <ModalFooter>
              <button
                className="danger-button"
                onClick={() => {
                  self.toggleRevertModal();
                  self.props.revertToOriginal(this.props.video.shortcode);
                }}
              >
                Undo
              </button>
            </ModalFooter>
          </Modal>
          {this.state.isFetching ||
          !this.props.video ||
          !getBestFile(this.props.video) ? (
            <div className="loading-indicator">
              <img src={AnimatedLogo} alt="presentation" />
            </div>
          ) : (
            <div ref="container">
              {this.props.video && this.props.video.waiting_for_best ? (
                <div
                  className="alert alert-warning"
                  style={{ textAlign: 'center' }}
                >
                  This video is still encoding the high resolution source file.
                  Please wait before editing if you wish to maintain the
                  original video quality.
                </div>
              ) : (
                ''
              )}
              {(this.state.targetVersion &&
                parseInt(this.props.video.version || 0, 10) !==
                  parseInt(this.state.targetVersion || 0, 10)) ||
              this.state.isProcessing ? (
                <Player video={this.props.video} />
              ) : (
                <VideoEditor
                  action={this.props.query.action}
                  noAudio={this.props.video.audio_channels === 0}
                  mobile={this.props.mobile}
                  duration={this.props.video.duration}
                  url={getBestFile(this.props.video).url}
                  videoHeight={getBestFile(this.props.video).height}
                  videoWidth={getBestFile(this.props.video).width}
                  poster={this.props.video.thumbnail_url}
                  mime="video/mp4"
                  doneButtonText="Save Changes"
                  autoPlay
                  onFinish={(options) => {
                    this.props
                      .retranscodeVideo(this.props.video, options)
                      .then((data) => {
                        browserHistory.goBack();
                      });
                  }}
                  onPlaybackError={this.props.onPlaybackError}
                />
              )}
              <Link
                className="footer-link"
                to={`/thumbnail/${this.props.video.shortcode}`}
                onClick={(e) => {
                  e.preventDefault();
                  browserHistory.replace(
                    `/thumbnail/${this.props.video.shortcode}`
                  );
                }}
              >
                Change Thumbnail
              </Link>
              {this.props.video.version > 0 ? (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a
                  className="footer-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    self.toggleRevertModal();
                  }}
                >
                  Revert to Original
                </a>
              ) : (
                ''
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProviders({ design: 'v1' })
)(Editor);
